const toggle_reviewer_additional_details = () => {

	const ACTION = 'toggle-additional-reviewer-details';

	$(document).on('click', '[data-action="'+ACTION+'"]', function() {

		const CLASSNAME_INITIAL = $(this).attr('data-toggle-class-initial');
		const CLASSNAME_OPEN = $(this).attr('data-toggle-class-open');

		const TITLE_INITIAL = $(this).attr('data-toggle-title-initial');
		const TITLE_OPEN = $(this).attr('data-toggle-title-open');
		
		const SELECTOR_LIST = '.'+themePrefix+'-result-list.'+themePrefix+'-result-list--reviewer';
		const SELECTOR_ITEM = '.'+themePrefix+'-result-list__item';

		const SELECTOR_ADDITIONAL_DETAILS = '.row.row--additional';

		const STATUS = 'status';

		const STATUS_OPEN = STATUS+' '+STATUS+'--open';
		const STATUS_CLOSED = STATUS+' '+STATUS+'--closed';

		let btnClassnameAct;
		let btnClassnameSet;
		let statusAct;
		let statusSet;
		let scroll = false;
		let titleSet;

		if($(this).hasClass(CLASSNAME_INITIAL)) {
			btnClassnameAct = CLASSNAME_INITIAL;
			btnClassnameSet = CLASSNAME_OPEN;
			statusAct = STATUS_CLOSED;
			statusSet = STATUS_OPEN;
			titleSet = TITLE_OPEN;

			$(SELECTOR_LIST).find('[data-action="'+ACTION+'"]')
				.removeClass(CLASSNAME_OPEN)
				.addClass(CLASSNAME_INITIAL)
				.attr('title',TITLE_INITIAL);

			$(SELECTOR_LIST).find(SELECTOR_ADDITIONAL_DETAILS)
				.removeClass(STATUS_OPEN)
				.addClass(STATUS_CLOSED);

			scroll = true;
		} 
		else {
			btnClassnameAct = CLASSNAME_OPEN;
			btnClassnameSet = CLASSNAME_INITIAL;
			statusAct = STATUS_OPEN;
			statusSet = STATUS_CLOSED;
			titleSet = TITLE_INITIAL;
		}

		$(this)
			.removeClass(btnClassnameAct)
			.addClass(btnClassnameSet)
			.attr('title',titleSet);
		
		$(this).parents(SELECTOR_ITEM).find(SELECTOR_ADDITIONAL_DETAILS)
			.removeClass(statusAct)
			.addClass(statusSet);

		if(scroll) {
			var $target = $(this);
			var $header = $('header');
			$('html, body').animate({
				scrollTop: $target.offset().top - $header.height() - 40 + 'px'
			}, 150);
		}

	});
}

$(function () {
	toggle_reviewer_additional_details();
});